export enum EhtmlContentTypes {
  SIMPLE_HTML = "simpleHtml",
  SLIDESHOW = "slideshow",
  GALLERY = "gallery",
  DOCUMENT_LIST = "list",
}
